module.exports = "<div class=\"admin-section\">\r\n\t<div class=\"row\">\r\n\t\t<div class=\"col-xs-12 col-md-2 sidebar\">\r\n\t\t\t<button class=\"btn btn-primary btn-users\">Users</button>\r\n\t\t\t<button class=\"btn btn-primary btn-players\">Players</button>\r\n\t\t\t<button class=\"btn btn-primary btn-groups\">Groups</button>\r\n\t\t\t<button class=\"btn btn-primary btn-rounds\">Rounds</button>\r\n\t\t\t<button class=\"btn btn-primary btn-news\">News</button>\r\n\t\t</div>\r\n\t\t<div class=\"col-xs-12 col-md-10 admin-sections-container\">\r\n\r\n\t\t</div>\r\n\t</div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/admin-section/admin-section.tpl.html
// module id = 42
// module chunks = 0